//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const CASHIER_HOSTS = [
  'cashier.casino777.es',
  'stage-cashier.casino777.es',
  'beta-cashier.casino777.es',
  'cashier.bet777.es',
  'stage-cashier.bet777.es',
  'beta-cashier.bet777.es'
]

function isCashierOrigin(origin) {
  try {
    return CASHIER_HOSTS.includes(new URL(origin).hostname)
  } catch (e) {
    return false
  }
}

export default {
  data() {
    return {
      minimised: false,
      fullWidth: false
    }
  },
  computed: {
    isOpen() {
      return this.$store.state.cashierOverlay.isOpen
    },
    url() {
      return this.$store.state.cashierOverlay.url
    },
    openNonce() {
      return this.$store.state.cashierOverlay.openNonce
    }
  },
  watch: {
    isOpen(open) {
      if (!open) {
        this.minimised = false
        this.fullWidth = false
      }
    },
    openNonce() {
      this.minimised = false
    }
  },
  mounted() {
    window.addEventListener('message', this.onCashierMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onCashierMessage)
  },
  methods: {
    close() {
      this.$store.commit('closeCashierOverlay')
    },
    notifyCashier(origin, action) {
      const frame = this.$refs.frame
      if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage({ action }, origin)
      }
    },
    closePaymentBrowser() {
      const browser = this.paymentBrowser
      this.paymentBrowser = null
      if (!browser) return
      browser._suppressExit = true
      if (browser.close) {
        try { browser.close() } catch (e) {}
      }
    },
    // Capacitor Browser opens a Chrome Custom Tab on Android, and neither
    // window.close() nor Browser.close() can dismiss it. Cordova InAppBrowser
    // stays under the app and can be closed when Neteller returns.
    openPaymentBrowser(url, origin) {
      const cordovaBrowser = window.cordova && window.cordova.InAppBrowser
      const open = typeof cordovaBrowser === 'function'
        ? cordovaBrowser
        : cordovaBrowser && typeof cordovaBrowser.open === 'function'
          ? cordovaBrowser.open.bind(cordovaBrowser)
          : null
      if (!open) return false
      try {
        this.closePaymentBrowser()
        const ref = open(url, '_blank', 'location=no,toolbar=yes,closebuttoncaption=Close,hardwareback=yes,hideurlbar=yes,hidenavigationbuttons=yes,zoom=no')
        if (!ref || typeof ref.addEventListener !== 'function') return false
        this.paymentBrowser = ref
        let returned = false
        ref.addEventListener('loadstop', (event) => {
          const loaded = event && event.url
          if (returned || typeof loaded !== 'string') return
          if (loaded.indexOf('deposit/result') === -1 || loaded.indexOf('embed=1') === -1) return
          returned = true
          this.notifyCashier(origin, 'paymentReturned')
          try { ref.close() } catch (e) {}
        })
        ref.addEventListener('exit', () => {
          if (this.paymentBrowser === ref) this.paymentBrowser = null
          if (returned || ref._suppressExit) return
          this.notifyCashier(origin, 'externalClosed')
        })
        return true
      } catch (e) {
        return false
      }
    },
    async watchExternalClose(browser, origin) {
      if (!browser.addListener) return
      if (this.externalCloseHandle) {
        this.externalCloseHandle.remove()
        this.externalCloseHandle = null
      }
      const handle = await browser.addListener('browserFinished', () => {
        this.notifyCashier(origin, 'externalClosed')
        if (this.externalCloseHandle) {
          this.externalCloseHandle.remove()
          this.externalCloseHandle = null
        }
      })
      this.externalCloseHandle = handle
    },
    onCashierMessage(event) {
      if (!isCashierOrigin(event.origin)) return
      if (!this.$refs.frame || event.source !== this.$refs.frame.contentWindow) return
      if (event.data && event.data.action === 'openExternal') {
        const target = event.data.url
        if (typeof target !== 'string' || !/^https:\/\//i.test(target)) return
        const browser = window.CapacitorBrowser || this.$CapacitorBrowser
        const inApp = this.system === 'app' || /; wv\)|SportifyApp/i.test(navigator.userAgent)
        if (inApp && this.openPaymentBrowser(target, event.origin)) return
        if (inApp && browser && browser.open) {
          this.watchExternalClose(browser, event.origin)
          browser.open({ url: target })
          return
        }
        window.open(target, '_blank')
        return
      }
      if (event.data && event.data.action === 'closeExternal') {
        if (this.paymentBrowser) {
          this.closePaymentBrowser()
          return
        }
        const browser = window.CapacitorBrowser || this.$CapacitorBrowser
        if (browser && browser.close) browser.close()
        return
      }
      if (event.data && event.data.action === 'openMail') {
        const mail = event.data.url
        if (typeof mail === 'string' && /^mailto:[^\s<>"']+$/i.test(mail)) {
          const cap = window.Capacitor
          const launcher = window.CapacitorAppLauncher
            || this.$CapacitorAppLauncher
            || (cap && cap.Plugins && cap.Plugins.AppLauncher)
            || (cap && typeof cap.registerPlugin === 'function' && cap.registerPlugin('AppLauncher'))
          const inApp = this.system === 'app' || /; wv\)|SportifyApp/i.test(navigator.userAgent)
          if (inApp && launcher && launcher.openUrl) {
            launcher.openUrl({ url: mail })
            return
          }
          if (inApp) return
          window.location.assign(mail)
        }
        return
      }
      if (!event.data || event.data.action !== 'closeCashier') return

      this.close()

      const next = event.data.url
      if (next == null || next === '') return
      if (typeof next === 'string' && /^https?:\/\//i.test(next) && next !== window.location.href) {
        window.location.assign(next)
      }
    },
    toggleFullWidth() {
      this.minimised = false
      this.fullWidth = !this.fullWidth
    }
  }
}
